module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Cloud-sun-f152ea743462e403bbc4ac0378490370.svg";